"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    emptyReports: {
        primaryText: 'No Reports Available',
        secondaryText: 'we could not show any reports by the moment, please try again later',
    },
};
